<template>
<AppLayout>
  <div class="transaction">
    <section id="transaction-products">
        <div class="container">
  
          <h6 style="margin-bottom: 0px;" class="fw-bold">Purchases</h6>
          <div class="warehouse-inventory-card-wrapper" v-if="loading">
            <SkeletonLoader type="stats" :count="6" />
          </div>
          <div v-else class="warehouse-inventory-card-wrapper">
            <div class="warehouse-inventory-card">
              <p>Purchase Orders this Month</p>
              <strong class="blue">{{purchasesMonth }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Purchase Orders Pending Approval</p>
              <strong class="blue">{{ purchasePending }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Purchase Orders Fulfilled</p>
              <strong class="blue">{{ purchasefulfilled }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Cancelled Purchase Orders</p>
              <strong class="red">{{ purchaseCancel }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Rejected Purchase Orders</p>
              <strong class="red">{{ purchaseReject }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p class="orange">Value of POs</p>
              <strong class="orange">KES {{ purchaseValue }}</strong>
            </div>
  
          </div> 
  
          <div class="filter-search" style="margin-top: 0px; padding-left: 0px;">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date From</label>
                      <input type="date" class="form-control" v-model="dateFrom">
                    </div>
                  </div>

                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date To</label>
                      <input type="date" class="form-control" v-model="dateTo">
                    </div>
                  </div>

                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">PO No.</label>
                      <input type="text" class="form-control" v-model="poNo">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Status</label>
                      <select class="full" id="handled-by" v-model="status">
                        <option value="all">All</option>
                        <option value="pending">Pending</option>
                        <option value="active">Approved</option>
                        <option value="rejected">Rejected</option>
                        <option value="fulfilled">Fulfilled</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Raised By</label>
                      <select class="full" id="handled-by" v-model="raisedById">
                        <option value="0">Any</option>
                        <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Approved By</label>
                      <select class="full" id="handled-by" v-model="approvedById">
                        <option value="0">Any</option>
                        <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!--
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Amount/Value</label>
                      <input type="number" class="form-control"  v-model="amount">
                    </div>
                  </div>
                  -->
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Project</label>
                      <input type="text" class="form-control" v-model="project">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Department</label>
                      <input type="text" class="form-control" v-model="departmentId">
                    </div>
                  </div>
                  
                  <div class="col-md-1 align-self-end">
                    <div class="form-group">
                      <button class="btn-style small" @click="search">Search</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list"  style="margin-top: 0px;">
                <!-- <keep-alive> -->
                <table id="purchasesTable" class="table table-hover">
                    <thead>
                        <th>No.</th>
                        <th>Date</th>
                        <th>PO No.</th>
                        <th>PR No.</th>
                        <th>Department</th>
                        <th>Project</th>
                        <th>Raised By</th>
                        <th>Status</th>
                        <th>Exception</th>
                        <th>Fulfilled By</th>
                        <th>Amount</th>
                        <th>Action</th>
                    </thead>
                </table>
                <SkeletonLoader v-if="loading" type="table" :rows="5" :columns="11" />
              <!-- </keep-alive> 
                <div v-if="purchases.length < 1">
                  <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No purchase found</label>
                </div>-->
                
                <!-- Discrepancies Modal -->
                <teleport to="body">
                  <div v-if="showDiscrepanciesModal" class="discrepancies-modal-overlay" @click.self="closeDiscrepancies">
                    <div class="discrepancies-modal-content">
                      <div class="discrepancies-modal-header">
                        <h4 class="mb-0">Discrepancies</h4>
                        <button type="button" class="btn-close" aria-label="Close" @click="closeDiscrepancies"></button>
                      </div>
                      <div class="discrepancies-modal-body">
                        <SkeletonLoader v-if="loading && showDiscrepanciesModal" type="text" :count="6" />
                        <template v-else>
                          <p v-if="discrepancyPurchaseNo" class="text-muted mb-2">PO: <strong>{{ discrepancyPurchaseNo }}</strong></p>
                          <table class="table table-sm table-bordered discrepancies-lines-table">
                          <thead>
                            <tr>
                              <th>Product</th>
                              <th>Ordered</th>
                              <th>Received</th>
                              <th>Remaining</th>
                              <th>Line exception</th>
                              <th>Batches &amp; comments</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="line in discrepancyLines"
                              :key="line.purchaseProductId"
                              :class="{ 'discrepancy-row-unfulfilled': line.notFulfilled }"
                            >
                              <td>{{ line.productName }}</td>
                              <td>{{ formatNumberSimple(line.orderedQty) }}</td>
                              <td>{{ formatNumberSimple(line.receivedQty) }}</td>
                              <td>{{ formatNumberSimple(line.remainingQty) }}</td>
                              <td>{{ line.lineException ? 'Yes' : '—' }}</td>
                              <td class="discrepancy-batches-cell">
                                <template v-if="line.fulfillmentBatches && line.fulfillmentBatches.length">
                                  <div v-for="fb in line.fulfillmentBatches" :key="line.purchaseProductId + '-' + fb.batchId + '-' + fb.qty" class="mb-2 d-flex align-items-center justify-content-between gap-2">
                                    <div class="flex-grow-1">
                                      <router-link :to="'/transaction/processedbatch/' + fb.batchId" class="batch-link">{{ fb.batchNo || ('Batch #' + fb.batchId) }}</router-link>
                                      <span v-if="fb.comment" class="text-muted"> — {{ fb.comment }}</span>
                                    </div>
                                    <button 
                                      v-if="fb.documents && fb.documents.length > 0"
                                      @click="openBPNDocuments(fb.batchNo || ('Batch #' + fb.batchId), fb.documents)"
                                      class="btn btn-sm btn-outline-primary"
                                      title="Preview BPN documents"
                                    >
                                      <i class="fas fa-file-pdf me-1"></i>BPN
                                    </button>
                                  </div>
                                </template>
                                <span v-else class="text-muted">—</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <details v-if="discrepanciesItems && discrepanciesItems.length" class="mt-3">
                          <summary class="small">Latest batch quantity/price variance (detail)</summary>
                          <table class="table table-sm mt-2">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>Original Qty</th>
                                <th>Fulfilled Qty</th>
                                <th>Remaining Qty</th>
                                <th>Batch Qty</th>
                                <th>Qty Diff</th>
                                <th>Purchase Price</th>
                                <th>Batch Price</th>
                                <th>Price Diff</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="it in discrepanciesItems" :key="'legacy-' + it.productId">
                                <td>{{ it.productName }}</td>
                                <td>{{ formatNumberSimple(it.originalQty) }}</td>
                                <td>{{ formatNumberSimple(it.alreadyReceived) }}</td>
                                <td>{{ formatNumberSimple(it.remainingQty) }}</td>
                                <td>{{ formatNumberSimple(it.batchQty) }}</td>
                                <td>{{ formatNumberSimple(it.qtyDiff) }}</td>
                                <td>{{ formatCurrency(it.purchasePrice) }}</td>
                                <td>{{ formatCurrency(it.batchPrice) }}</td>
                                <td>{{ formatCurrency(it.priceDiff) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </details>
                        <div style="margin-top: 11px; display:flex; gap:11px; justify-content:flex-end; align-items:center; flex-wrap:wrap;">
                          <div style="font-weight:bold">Variance totals (latest batch):</div>
                          <div>Qty: {{ formatNumberSimple(discrepancyTotals?.totalQuantityDiscrepancy || 0) }}</div>
                          <div>Price: {{ formatCurrency(discrepancyTotals?.totalPriceDiscrepancy || 0) }}</div>
                          <button class="btn btn-default" @click="closeDiscrepancies">Close</button>
                        </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </teleport>

                <!-- Document Viewer for BPN Documents -->
                <DocumentViewer 
                  ref="documentViewer"
                  v-if="selectedDocuments.length > 0"
                  :documents="selectedDocuments"
                  :initial-index="0"
                  :url-server="$config?.apiUrl || process.env.VUE_APP_URL"
                />
          </div>
        </div>
    </section>
  </div>
</AppLayout>
</template>
  
  <script>
  import { docFooter } from '../../utils/common'
  import { mapGetters, mapActions } from 'vuex'
  import { getPurchaseTotalAmount } from '@/constants/purchaseCeoThreshold.js'
  // sweetalert replaced by vuetoastify toasts
  import AppLayout from '../../components/AppLayout.vue';
  import SkeletonLoader from '../../components/SkeletonLoader.vue'
  import DocumentViewer from '../../components/DocumentViewer.vue'
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';

  export default {
    name: 'HomePurchases',
    components: {
      AppLayout,
      SkeletonLoader,
      // eslint-disable-next-line vue/no-unused-components
      DocumentViewer
    },

    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        purchasesMonth:0,
        purchasePending: 0,
        purchasefulfilled: "0/0",
        purchaseCancel:0,
        purchaseReject: 0,
        purchaseValue: "0",
        purchases: [],
        dateFrom: '', 
        dateTo: '',
        status: "", 
        raisedById: 0, 
        approvedById: 0, 
        dataTable:  null,
        processedData: [],
        loading: false, 
        amount: 0.0, 
        project: "", 
        departmentId: "",
        poNo: "",
        purchaseDatas: [],
        showDiscrepanciesModal: false,
        discrepanciesItems: [],
        discrepancyTotals: {},
        discrepancyLines: [],
        discrepancyPurchaseNo: '',
        showDocumentViewer: false,
        selectedDocuments: [],
        selectedBatchNo: '',

    }),
      mounted(){
        this.fetchUsers()
        this.getPurchases()
      window.deleteAlert = this.deleteAlert;
      window.openDiscrepancies = this.openDiscrepancies;
      // expose the global name used by HomeOrders (inline onClick style)
      window.showDiscrepancies = this.openDiscrepancies;
    },

    computed:{
      ... mapGetters (["getUsers"]),
      users () { return this.getUsers },
    },
    methods:{
      ... mapActions(["fetchUsers"]),
      formatDate(date, isFull = false) {
        if (!date) return '-'
        const d = new Date(date)
        if (isNaN(d.getTime())) return date
        const options = isFull === 'true' || isFull === true
          ? { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
          : { year: 'numeric', month: 'short', day: 'numeric' }
        return d.toLocaleDateString('en-GB', options)
      },
      formatMoney(val, currency = 'KES') {
        try {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'KES',
            currencyDisplay: 'code',
            maximumFractionDigits: 2
          }).format(Number(val || 0));
        } catch (e) {
          return val;
        }
      },
      formatNumberSimple(val) {
        try {
          return new Intl.NumberFormat('en-US').format(Number(val || 0));
        } catch (e) {
          return val;
        }
      },
      formatCurrency(val) {
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES', currencyDisplay: 'code', maximumFractionDigits: 2 }).format(Number(val || 0));
        } catch (e) {
          return val;
        }
      },
      preprocessData(rawData) {
        return rawData.map(item => {
          let status =  "";
          let purchaseNo =  "";
          let exception =  "";
          let fulfilledName =  "";

          if(item.batchNo){
            purchaseNo = `${item.purchaseNo} <span style="font-size: 13px;"> - ${item.batchNo}</span>`
          } else {
            purchaseNo = item.purchaseNo
          }

          if(item.exception == 0){
            exception = '<button class="btn btn-primary btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; margin-left: 5px; border-radius: 10px">OK</button>'
          } else {
            exception = '<button class="btn btn-danger btn-sm" style="font-size: 11px !important; margin-left: 5px; border-radius: 10px">!</button>'
          }
          

          if(item.fulfilledName){
            fulfilledName = item.fulfilledName
          } else {
            fulfilledName = ' - '
          }
          
          // normalize status for comparisons
          const st = (item.status || '').toString().toLowerCase();
          if(st == 'completed'){
            status = '<button class="btn btn-success btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Completed</button>'
          } else if(st == 'fulfilled'){
            status = '<button class="btn btn-primary btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Fulfilled</button>'
          } else if(st == 'partial' || st == 'partially' || st == 'partially_fulfilled'){
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Partially fulfilled</button>'
          } else if(st == 'cancelled'){
            status = '<button class="btn btn-danger btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Cancelled</button>'
          } else if(st == 'rejected'){
            status = '<button class="btn btn-danger btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Rejected</button>'
          } else if(st == 'approved'){
            // Procurement approved -> yellow badge
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Pending</button>'
          } else if(st == 'verified'){
            // HOD approved -> orange badge
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; background-color: orange; border-radius: 15px">HOD approved</button>'
          } else if(st == 'stamped'){
            // Finance approved: green if canBeFulfilled, orange otherwise
            const rawCan = (item.canBeFulfilled !== undefined && item.canBeFulfilled !== null) ? item.canBeFulfilled : item.canBefulfilled;
            const canFulfill = (typeof rawCan === 'boolean' && rawCan === true)
              || (typeof rawCan === 'string' && ['true', '1', 'yes'].includes(rawCan.toLowerCase()))
              || (Number(rawCan) === 1);
            if (canFulfill) {
              status = '<button class="btn btn-success btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Finance approved</button>'
            } else {
              status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; background-color: orange; border-radius: 15px">Finance approved</button>'
            }
          } else if(st == 'pending'){
            status = '<button class="btn btn-warning btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px" >Pending</button>'
          } else if(st == 'saved' || st == 'draft'){
            // Saved should display as Draft
            status = '<button class="btn btn-secondary btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border-radius: 15px">Draft</button>'
          } else {
            status = `<button class="btn btn-default btn-sm" style="text-transform: capitalize !important; font-size: 11px !important; border: 1px solid #000000; border-radius: 15px" >${item.status}</button>`
          }

          return {
            indexNo:"1",
            createdAt: this.formatDate(item.createdAt),
            purchaseNo,
            prNo: item.prNo || '-',
            // prefer joined Department name (department) or fallback to various fields
            department: (item.department && item.department !== '') ? item.department : (item.departmentName || (item.Department && item.Department.name) || ''),
            project: item.project,
            raisedName: item.name,
            status,
            exception,
            fulfilledName,
            amount: this.formatMoney(getPurchaseTotalAmount(item), item.currency),
            action:'',
            itemId: item.id,
            hasException: !!item.exception,
            statusRow: item.status
          };
        });
      },

      reinitializeTable(){
        this.dataTable.clear()
        this.dataTable.rows.add(this.preprocessData(this.purchaseDatas))
        this.dataTable.draw()
      },


    clear(){
        this.status = ""
        this.raisedById = 0
        this.approvedById = 0
        this.amount = 0.0
        this.projectId = 0
        this.departmentId = ""
        this.poNo= ""
        this.reinitializeTable()
      }, 

      initializeDataTable() {
        try{
          this.dataTable = $(this.$el).find('#purchasesTable').DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            destroy: true,
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6, 7, 9, 10], // Export relevant data columns, skip No. and Action
                format: {
                  body: (data) => {
                    // Strip HTML from cells (like status badges)
                    return typeof data === 'string' ? data.replace(/<[^>]*>?/gm, '').trim() : data;
                  }
                }
              },
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'portrait', 
                exportOptions: {
                  columns: [1, 2, 3, 4, 5, 6, 7, 9, 10],
                  format: {
                    body: (data) => {
                      return typeof data === 'string' ? data.replace(/<[^>]*>?/gm, '').trim() : data;
                    }
                  }
                },
                customize: this.customizePDF
              },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'createdAt' },
              { data: 'purchaseNo' }, 
              { data: 'prNo' },
              { data: 'department' }, 
              { data: 'project' }, 
              { data: 'raisedName' }, 
              { data: 'status' }, 
              { data: 'exception' },
              { data: 'fulfilledName' }, 
              { data: 'amount' }, 
              { data: 'action', render:this.renderActionButton }
            ],
            columnDefs: [
              {
                targets: 0,  searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });

          // attach delegated handlers for buttons rendered inside the DataTable
          const $table = $(this.$el).find('#purchasesTable');
          // discrepancies buttons use inline onClick (showDiscrepancies); keep delete handler
          // delegate both to the table and document to be robust against DataTables re-rendering
          $table.off('click.deleteNamespace', '.btn-delete').on('click.deleteNamespace', '.btn-delete', (e) => {
            const id = $(e.currentTarget).data('id');
            console.debug('btn-delete clicked (table delegate), id=', id);
            this.deleteAlert(id);
          });
          $(document).off('click.deleteNamespace', '.btn-delete').on('click.deleteNamespace', '.btn-delete', (e) => {
            const id = $(e.currentTarget).data('id');
            console.debug('btn-delete clicked (document delegate), id=', id);
            this.deleteAlert(id);
          });

        } catch(error){
          console.log({error})
        }
      },

      closeDiscrepancies(){
        this.showDiscrepanciesModal = false;
        this.discrepanciesItems = [];
        this.discrepancyTotals = {};
        this.discrepancyLines = [];
        this.discrepancyPurchaseNo = '';
      },

      openBPNDocuments(batchNo, documents) {
        if (!documents || documents.length === 0) {
          if (this.$toast && typeof this.$toast.info === 'function') {
            this.$toast.info('No BPN documents found for this batch');
          }
          return;
        }
        this.selectedDocuments = documents;
        this.selectedBatchNo = batchNo;
        this.showDocumentViewer = true;
        this.$nextTick(() => {
          if (this.$refs.documentViewer) {
            this.$refs.documentViewer.open(0);
          }
        });
      },

      closeDocumentViewer() {
        this.showDocumentViewer = false;
        this.selectedDocuments = [];
        this.selectedBatchNo = '';
      },

      renderActionButton(data, type, row) {
        if (type === 'display') {
          let action = '';
          const status = (row.statusRow || '').toString().toLowerCase();
          let perm = {}
          try {
            perm = JSON.parse(localStorage.getItem('permission') || '{}')
          } catch (e) {
            perm = {}
          }
          const canEditPurchase =
            perm.purchaseAdd === true ||
            perm.purchaseManage === true ||
            perm.approvePurchase === true
          // Before HOD approval: statuses pending / approved (procurement). verified+ = HOD or later — not editable here.
          const editableBeforeHod =
            status === 'pending' ||
            status === 'approved'
          // show delete only when purchase is in 'saved' state
          if (status === 'saved' || status === 'draft') {
            action += `<button class="btn btn-sm btn-danger btn-delete" style="margin-right: 10px;" data-id="${row.itemId}" onClick="deleteAlert(${row.itemId})">Delete</button>`;
            action += `<a class="btn btn-sm btn-primary" style="margin-right: 10px;" href="/purchases/add?purchaseId=${row.itemId}">Edit</a>`;
          } else if (editableBeforeHod && canEditPurchase) {
            action += `<a class="btn btn-sm btn-primary" style="margin-right: 10px;" href="/purchases/add?purchaseId=${row.itemId}">Edit</a>`;
          }
          // only show discrepancies button when the purchase is partially fulfilled
          if (status === 'partial' || status === 'partially' || status === 'partially_fulfilled') {
            action += `<button class="btn btn-sm btn-secondary btn-discrepancies" style="margin-right: 10px;" data-id="${row.itemId}" onClick="showDiscrepancies(${row.itemId})">Discrepancies</button>`;
          }
          action += `<a class="btn btn-sm btn-default" style="border: 1px solid black; padding-top:1px !important; padding-bottom: 1px !important" href="/purchases/pdf/${row.itemId}">View</a>`;
          return action;
        }
        return data;
      },
     

      async search(){
        console.log("Raised by Id",this.raisedById)
        console.log("Approved by Id", this.approvedById)
        console.log(this.approvedById)
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                poNo: this.poNo,
                status: this.status, 
                raisedById: this.raisedById, 
                approvedById: this.approvedById,
                amount: this.amount,
                project: this.project,
                departmentId: this.departmentId,
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/search', requestOptions)
        const data = await res.json()
        console.log("Response", data)
        if(data.status == true){
            this.purchases = data.purchases
            this.dataTable.clear();
            this.dataTable.rows.add(this.preprocessData(this.purchases));
            this.dataTable.draw();
        }else{
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Search failed. Try again')
        }
      },

      customizePDF(doc) {
        const profile = JSON.parse(localStorage.getItem('profile'))
        doc.pageMargins = [40, 40, 40, 40]; 
        doc.defaultStyle.columnGap = 0
        doc.content[1].fillColor = '#ffffff'

        doc.header = () => {
          return {
            columns: [
              {
                width: '*',
                columns: [
                  /* {
                      image: logoBase64,
                      width: 150, // Adjust the width as needed
                  },*/
                  {
                    text: profile?.businessName,
                    alignment: 'left',
                    margin: [40, 15, 0, 40], // Adjust margins as needed
                    color: '#FFA500', // Orange color
                    bold: true,
                    fontSize: 14,

                  }
                ]
              },
              {
                width: '*',
                stack: [
                  {
                    text: 'Purchases',
                    alignment: 'right',
                    margin: [0, 15, 50, 0],
                    fontSize: 12,
                    color: '#000000'
                  },
                  {  
                    alignment: 'right',
                    margin: [300, 0, 0, 0],
                    width: '*',
                    columns: [
                      {
                        width: 'auto',
                        text: 'Date:',
                        alignment: 'right',
                        margin: [0, 0, 10, 0],
                        bold: true,
                      },
                      {
                        width: 'auto',
                        text: `${this.formatDate(new Date(), "true")}`,
                        alignment: 'right',
                        margin: [0, 0, 50, 0],
                        fontSize: 9
                      }
                    ]
                  }
                ]
              }
            ],
            fillColor: '#000000'
          };
        },

        doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

        doc.styles.title = {
          color: '#000000',
          fontSize: 13,
          margin: [80, 0, 0, 40],
        };
      },


      async getPurchases () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          
          try{
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL+'/purchases', requestOptions)
            const data = await res.json()
            this.purchases = data.purchases || []
            console.log(this.purchases)
            this.purchaseDatas = this.purchases
            this.processedData = this.preprocessData(this.purchases);

            // compute summary metrics for the dashboard cards
            const purchasesArr = this.purchases || [];
            const now = new Date();
            const currentMonth = now.getMonth();
            const currentYear = now.getFullYear();
            this.purchasesMonth = purchasesArr.filter(p => {
              const d = p.createdAt ? new Date(p.createdAt) : null;
              return d && d.getMonth() === currentMonth && d.getFullYear() === currentYear;
            }).length;
            this.purchasePending = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'pending').length;
            const fulfilledCount = purchasesArr.filter(p => {
              const s = (p.status || '').toString().toLowerCase();
              return s === 'fulfilled' || s === 'completed';
            }).length;
            this.purchasefulfilled = `${fulfilledCount}/${purchasesArr.length}`;
            this.purchaseCancel = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'cancelled').length;
            this.purchaseReject = purchasesArr.filter(p => (p.status || '').toString().toLowerCase() === 'rejected').length;
            const totalValue = purchasesArr.reduce((acc, p) => acc + (Number(p.amount) || 0), 0);
            this.purchaseValue = new Intl.NumberFormat('en-US').format(totalValue);
            //if(typeof this.dataTable == 'null'){
            this.dataTable = null;
            this.initializeDataTable();
            // close any open discrepancies modal when leaving
            this.showDiscrepanciesModal = false;
            // } else {
            //   this.dataTable.destroy()
            //   this.dataTable = null;
            //   this.initializeDataTable();
            // }
          }catch(err){
              console.log(err)
          }finally{
              this.loading = false
          }
      },
      deleteAlert(id){
          // replace modal confirm with native confirm and show toast notifications
          const confirmed = window.confirm('Confirm Purchase Order Deletion. This action cannot be reverted. Proceed?');
          if (confirmed) {
            this.deletePurchase(id);
          } else {
            if (this.$toast && typeof this.$toast.info === 'function') this.$toast.info('Deletion cancelled');
          }
      },

      // Discrepancies modal rendering data below

      async deletePurchase(id) {
        const requestOptions = {
              method: "DELETE",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token }
          };
          try{
            this.loading = true;
            const res = await fetch(process.env.VUE_APP_URL+'/purchases/'+id, requestOptions)
            const data = await res.json()
            if(data.status == true){
                if (this.$toast && typeof this.$toast.success === 'function') this.$toast.success('Saved Purchase Order deleted successfully');
              this.getPurchases()
              this.clear()
            }else{
                if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Purchase Order not deleted');
            }
          }catch(e){
            console.error(e);
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to delete purchase order');
          }finally{
            this.loading = false;
          }
      },

      async openDiscrepancies(purchaseId){
        console.debug('openDiscrepancies called with', purchaseId);
        try{
          const requestOptions = { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer '+this.token } };
          const res = await fetch(process.env.VUE_APP_URL+`/purchases/${purchaseId}/discrepancies`, requestOptions);
          const data = await res.json();
          if(data.status == true){
            const items = data.items || [];
            const totals = data.totals || {};
            const lines = data.lines || [];

            // populate the Vue modal with discrepancies and show it
            this.discrepanciesItems = items;
            this.discrepancyTotals = totals;
            this.discrepancyLines = lines;
            this.discrepancyPurchaseNo = data.purchaseNo || '';
            this.showDiscrepanciesModal = true;
          } else {
            if (this.$toast && typeof this.$toast.info === 'function') this.$toast.info(data.message || 'No discrepancies found');
          }
        }catch(e){
          console.error(e);
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to load discrepancies');
        }
      }
    },
    beforeRouteLeave() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null
      }
    }

  }
  </script>

  <style scoped>
  .purchases-list{
    padding: 20px;
    margin-top: 30px;
    box-shadow: rgba(49, 32, 104, 0.2) 0 2px 8px 0;
  }
  /* Prevent horizontal scroll: ensure table fits its container and buttons wrap */
  .purchases-list{
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .purchases-list table{
    width: 100%;
    max-width: 100%;
    table-layout: auto;
    box-sizing: border-box;
  }
  .purchases-list table th,
  .purchases-list table td{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
  /* allow DataTables buttons to wrap to next line instead of forcing extra width */
  .purchases-list .dt-buttons{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  </style>

<style>
/* Discrepancies modal - global so teleport works */
.discrepancies-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  padding: 20px;
}

.discrepancies-modal-content {
  background: white;
  border-radius: 8px;
  max-width: 95vw;
  width: 100%;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.discrepancies-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.discrepancies-modal-body {
  padding: 20px;
  overflow: auto;
}

.discrepancies-lines-table .discrepancy-row-unfulfilled {
  background-color: #fff3cd;
}

.discrepancies-lines-table .batch-link {
  font-weight: 600;
  text-decoration: underline;
}

.discrepancy-batches-cell {
  max-width: 400px;
  white-space: normal;
  word-break: break-word;
}

.discrepancy-batches-cell .btn {
  font-size: 11px;
  padding: 4px 8px;
  white-space: nowrap;
}
</style>